export const textContent = (node) => {
    if (!node)
        return '';
    if (node instanceof Array)
        return node.map(textContent).join('');
    if (node instanceof Object && 'props' in node)
        return textContent(node.props.children);
    return String(node);
};
//# sourceMappingURL=textContent.js.map